const denimSizes = [
  "W26 / L30",
  "W28 / L30",
  "W30 / L32",
  "W32 / L32",
  "W34 / L32",
  "W36 / L34",
];

const apparelSizes = ["XS", "S", "M", "L", "XL"];

const makeImages = (id) => {
  const number = String(id).padStart(2, "0");
  return [
    `/img/products/product-${number}.jpg`,
    `/img/products/product-${number}-detail.jpg`,
  ];
};

const productCatalog = [
  {
    id: 1,
    name: "North Loom Dry Indigo",
    category: "Jeans",
    price: 210,
    images: makeImages(1),
    image: makeImages(1)[0],
    description:
      "A regular straight jean cut from crisp 13.5 oz dry denim. The deep indigo surface is designed to record every commute, concert, and repair.",
    attributes: { gender: "Men", fit: "Regular", waist: "Mid", leg: "Straight", material: "100% organic cotton", weight: "13.5 oz", madeIn: "Hong Kong", colorHex: "#162b47" },
    tags: ["dry denim", "organic", "core"],
    size: denimSizes,
    colors: ["Dry Indigo"],
    features: ["Rigid ring-spun denim", "Button fly", "Tobacco stitching", "Copper-tone trims"],
    badge: "Core fit",
    newArrival: false,
  },
  {
    id: 2,
    name: "Harbor Wide Deep Rinse",
    category: "Jeans",
    price: 225,
    images: makeImages(2),
    image: makeImages(2)[0],
    description:
      "Generous through the seat and thigh with a high rise and wide leg. A single rinse keeps the indigo dark while softening the hand.",
    attributes: { gender: "Men", fit: "Loose", waist: "High", leg: "Wide", material: "100% organic cotton", weight: "13 oz", madeIn: "Hong Kong", colorHex: "#20334c" },
    tags: ["loose", "dark wash", "organic"],
    size: denimSizes,
    colors: ["Deep Rinse"],
    features: ["Rigid denim", "High waist", "Wide leg", "Reinforced back pockets"],
    badge: "New",
    newArrival: true,
  },
  {
    id: 3,
    name: "Ridge Regular Pale Sky",
    category: "Jeans",
    price: 195,
    images: makeImages(3),
    image: makeImages(3)[0],
    description:
      "An easy straight-leg jean in a pale, sun-washed blue. Soft abrasion and subtle marbling give it the feel of a long-kept favorite.",
    attributes: { gender: "Men", fit: "Regular", waist: "Mid", leg: "Straight", material: "100% organic cotton", weight: "12.25 oz", madeIn: "Hong Kong", colorHex: "#8ea9be" },
    tags: ["washed", "straight", "summer"],
    size: denimSizes,
    colors: ["Pale Sky"],
    features: ["Rigid denim", "Zip fly", "Soft vintage wash", "Indigo pocket embroidery"],
    badge: "New",
    newArrival: true,
  },
  {
    id: 4,
    name: "Transit Taper Blue Black",
    category: "Jeans",
    price: 205,
    images: makeImages(4),
    image: makeImages(4)[0],
    description:
      "Roomy at the top and clean at the ankle, this tapered fit uses blue-black denim that reveals indigo character as it wears.",
    attributes: { gender: "Men", fit: "Tapered", waist: "Mid", leg: "Tapered", material: "99% organic cotton, 1% elastane", weight: "12 oz", madeIn: "Hong Kong", colorHex: "#182126" },
    tags: ["tapered", "stretch", "blue black"],
    size: denimSizes,
    colors: ["Blue Black"],
    features: ["Comfort stretch", "Zip fly", "Blackened copper trims", "Tonal stitching"],
    newArrival: false,
  },
  {
    id: 5,
    name: "Coast Loose Salt Wash",
    category: "Jeans",
    price: 220,
    images: makeImages(5),
    image: makeImages(5)[0],
    description:
      "A relaxed wide-leg jean with a bright, salt-faded wash. Built with a firm organic denim that softens beautifully with wear.",
    attributes: { gender: "Men", fit: "Loose", waist: "High", leg: "Wide", material: "100% organic cotton", weight: "12.75 oz", madeIn: "Hong Kong", colorHex: "#a8bfcc" },
    tags: ["loose", "light wash", "organic"],
    size: denimSizes,
    colors: ["Salt Wash"],
    features: ["Rigid denim", "Button fly", "Wide hem", "Hand-finished abrasion"],
    badge: "Limited",
    newArrival: true,
  },
  {
    id: 6,
    name: "Field Taper Natural Ecru",
    category: "Jeans",
    price: 185,
    images: makeImages(6),
    image: makeImages(6)[0],
    description:
      "A relaxed tapered jean that leaves the cotton undyed. Tiny natural flecks remain visible, celebrating the fiber rather than hiding it.",
    attributes: { gender: "Men", fit: "Tapered", waist: "Mid", leg: "Tapered", material: "100% organic cotton", weight: "11.5 oz", madeIn: "Hong Kong", colorHex: "#ddd5c1" },
    tags: ["undyed", "natural", "tapered"],
    size: denimSizes,
    colors: ["Natural Ecru"],
    features: ["Undyed organic denim", "Corozo buttons", "Natural thread", "Low-impact finish"],
    newArrival: false,
  },
  {
    id: 7,
    name: "Relay Cargo Washed Black",
    category: "Pants",
    price: 230,
    images: makeImages(7),
    image: makeImages(7)[0],
    description:
      "Workwear trousers with articulated knees and low-profile cargo pockets, garment washed to a soft graphite black.",
    attributes: { gender: "Men", fit: "Loose", waist: "Mid", leg: "Straight", material: "100% organic cotton", weight: "11 oz", madeIn: "Hong Kong", colorHex: "#393a39" },
    tags: ["cargo", "workwear", "washed black"],
    size: denimSizes,
    colors: ["Washed Black"],
    features: ["Six-pocket construction", "Reinforced knee", "Button fly", "Garment dyed"],
    badge: "New",
    newArrival: true,
  },
  {
    id: 8,
    name: "Studio Slim Midnight",
    category: "Jeans",
    price: 200,
    images: makeImages(8),
    image: makeImages(8)[0],
    description:
      "A slim, softly tapered jean in inky midnight denim. A touch of stretch adds movement without losing the authentic surface.",
    attributes: { gender: "Men", fit: "Slim", waist: "Mid", leg: "Tapered", material: "99% organic cotton, 1% elastane", weight: "11.75 oz", madeIn: "Hong Kong", colorHex: "#1a2730" },
    tags: ["slim", "stretch", "dark wash"],
    size: denimSizes,
    colors: ["Midnight"],
    features: ["Comfort stretch", "Zip fly", "Tonal seams", "Dark copper trims"],
    newArrival: false,
  },
  {
    id: 9,
    name: "Arc High Wide Indigo",
    category: "Jeans",
    price: 215,
    images: makeImages(9),
    image: makeImages(9)[0],
    description:
      "A high-rise jean with a long, wide A-line leg. Clean indigo denim and confident proportions make it an everyday statement.",
    attributes: { gender: "Women", fit: "Loose", waist: "High", leg: "Wide", material: "100% organic cotton", weight: "13 oz", madeIn: "Hong Kong", colorHex: "#284363" },
    tags: ["high rise", "wide", "organic"],
    size: denimSizes,
    colors: ["Clean Indigo"],
    features: ["Rigid denim", "High waist", "Button fly", "Long wide leg"],
    badge: "Bestseller",
    newArrival: false,
  },
  {
    id: 10,
    name: "Orbit Barrel Pale Blue",
    category: "Jeans",
    price: 205,
    images: makeImages(10),
    image: makeImages(10)[0],
    description:
      "A sculpted barrel-leg jean with room through the thigh and a neat ankle. The airy pale-blue wash highlights every curved seam.",
    attributes: { gender: "Women", fit: "Relaxed", waist: "High", leg: "Barrel", material: "100% organic cotton", weight: "12 oz", madeIn: "Hong Kong", colorHex: "#a2b8c7" },
    tags: ["barrel", "light wash", "high rise"],
    size: denimSizes,
    colors: ["Pale Blue"],
    features: ["Curved outseam", "Rigid denim", "Zip fly", "Cropped length"],
    badge: "New",
    newArrival: true,
  },
  {
    id: 11,
    name: "Mira Straight Faded Black",
    category: "Jeans",
    price: 195,
    images: makeImages(11),
    image: makeImages(11)[0],
    description:
      "High-waisted straight jeans with a dry, faded-black character. The clean cut works equally well cuffed or worn full length.",
    attributes: { gender: "Women", fit: "Regular", waist: "High", leg: "Straight", material: "100% organic cotton", weight: "12.5 oz", madeIn: "Hong Kong", colorHex: "#444442" },
    tags: ["black", "straight", "high rise"],
    size: denimSizes,
    colors: ["Faded Black"],
    features: ["Rigid denim", "High waist", "Zip fly", "Soft enzyme wash"],
    newArrival: false,
  },
  {
    id: 12,
    name: "Line High Slim Dry Indigo",
    category: "Jeans",
    price: 200,
    images: makeImages(12),
    image: makeImages(12)[0],
    description:
      "A close, high-rise silhouette in compact dry denim. Worn unwashed, it develops sharp creases and a highly personal fade map.",
    attributes: { gender: "Women", fit: "Slim", waist: "High", leg: "Slim", material: "99% organic cotton, 1% elastane", weight: "12 oz", madeIn: "Hong Kong", colorHex: "#1d3654" },
    tags: ["dry denim", "slim", "high rise"],
    size: denimSizes,
    colors: ["Dry Indigo"],
    features: ["Compact comfort stretch", "High waist", "Zip fly", "Unwashed finish"],
    newArrival: false,
  },
  {
    id: 13,
    name: "Flora Bootcut Worn Blue",
    category: "Jeans",
    price: 210,
    images: makeImages(13),
    image: makeImages(13)[0],
    description:
      "A fitted high-rise jean that opens gently below the knee. The lively mid-blue wash follows the grain of the denim.",
    attributes: { gender: "Women", fit: "Slim", waist: "High", leg: "Bootcut", material: "99% organic cotton, 1% elastane", weight: "12.25 oz", madeIn: "Hong Kong", colorHex: "#54799a" },
    tags: ["bootcut", "worn wash", "stretch"],
    size: denimSizes,
    colors: ["Worn Blue"],
    features: ["Comfort stretch", "High waist", "Zip fly", "Full-length bootcut"],
    badge: "New",
    newArrival: true,
  },
  {
    id: 14,
    name: "Workshop Denim Skirt Indigo",
    category: "Skirts",
    price: 165,
    images: makeImages(14),
    image: makeImages(14)[0],
    description:
      "A long A-line workwear skirt with a front split and oversized patch pockets, made in deep indigo rigid denim.",
    attributes: { gender: "Women", fit: "A-line", waist: "High", leg: "Maxi", material: "100% organic cotton", weight: "12 oz", madeIn: "Hong Kong", colorHex: "#233e5c" },
    tags: ["skirt", "workwear", "indigo"],
    size: apparelSizes,
    colors: ["Indigo"],
    features: ["Rigid denim", "Front split", "Utility pockets", "Corozo button"],
    newArrival: false,
  },
  {
    id: 15,
    name: "Foundry Denim Jacket Dry Indigo",
    category: "Jackets",
    price: 245,
    images: makeImages(15),
    image: makeImages(15)[0],
    description:
      "A boxy unisex denim jacket with generous patch pockets and clean metal hardware. The dry surface is ready to make its own history.",
    attributes: { gender: "Unisex", fit: "Relaxed", waist: "Hip length", leg: "—", material: "100% organic cotton", weight: "13.5 oz", madeIn: "Hong Kong", colorHex: "#172e4b" },
    tags: ["jacket", "dry denim", "unisex"],
    size: apparelSizes,
    colors: ["Dry Indigo"],
    features: ["Rigid denim", "Four-pocket front", "Adjustable hem tabs", "Copper-tone buttons"],
    badge: "New",
    newArrival: true,
  },
  {
    id: 16,
    name: "Sunday Denim Shirt Sky Blue",
    category: "Shirts",
    price: 175,
    images: makeImages(16),
    image: makeImages(16)[0],
    description:
      "An easy unisex overshirt in soft, light-washed denim with a rounded hem and workwear-inspired chest pockets.",
    attributes: { gender: "Unisex", fit: "Relaxed", waist: "Longline", leg: "—", material: "100% organic cotton", weight: "7.5 oz", madeIn: "Hong Kong", colorHex: "#91adbf" },
    tags: ["shirt", "light wash", "unisex"],
    size: apparelSizes,
    colors: ["Sky Blue"],
    features: ["Lightweight denim", "Twin chest pockets", "Corozo buttons", "Garment washed"],
    newArrival: false,
  },
  {
    id: 17,
    name: "Signal Chore Jacket Clay",
    category: "Jackets",
    price: 260,
    images: makeImages(17),
    image: makeImages(17)[0],
    description:
      "A practical chore jacket made from densely woven organic duck canvas, pigment dyed for a dry clay tone that gains character with wear.",
    attributes: { gender: "Men", fit: "Regular", waist: "Hip length", leg: "—", material: "100% organic cotton", weight: "11 oz", madeIn: "Hong Kong", colorHex: "#8b6248" },
    tags: ["canvas", "chore jacket", "workwear"],
    size: apparelSizes,
    colors: ["Clay"],
    features: ["Organic duck canvas", "Three patch pockets", "Unlined construction", "Garment dyed"],
    badge: "New",
    newArrival: true,
  },
  {
    id: 18,
    name: "Alma Cropped Jacket Worn Blue",
    category: "Jackets",
    price: 235,
    images: makeImages(18),
    image: makeImages(18)[0],
    description:
      "A compact denim jacket with dropped shoulders and a cropped waist. Its authentic worn-blue wash brings softness without losing structure.",
    attributes: { gender: "Women", fit: "Relaxed", waist: "Cropped", leg: "—", material: "100% organic cotton", weight: "12.5 oz", madeIn: "Hong Kong", colorHex: "#6686a0" },
    tags: ["jacket", "cropped", "washed denim"],
    size: apparelSizes,
    colors: ["Worn Blue"],
    features: ["Rigid denim", "Dropped shoulder", "Adjustable waist tabs", "Vintage wash"],
    newArrival: false,
  },
  {
    id: 19,
    name: "Keep It Moving Tee Chalk",
    category: "T-Shirts",
    price: 70,
    images: makeImages(19),
    image: makeImages(19)[0],
    description:
      "A heavyweight organic-cotton tee with a relaxed neckline and a softly worn chalk finish. Clean, durable, and made for repeat wear.",
    attributes: { gender: "Unisex", fit: "Regular", waist: "Hip length", leg: "—", material: "100% organic cotton", weight: "220 gsm", madeIn: "Hong Kong", colorHex: "#e7e1d4" },
    tags: ["tee", "organic jersey", "unisex"],
    size: apparelSizes,
    colors: ["Chalk"],
    features: ["Heavyweight jersey", "Ribbed neck", "Garment dyed", "Side-seam free body"],
    newArrival: false,
  },
  {
    id: 20,
    name: "Archive Crew Sweatshirt Coal",
    category: "Sweatshirts",
    price: 145,
    images: makeImages(20),
    image: makeImages(20)[0],
    description:
      "A roomy loopback sweatshirt with a compact rib neck and washed coal surface. Built for layering over denim through every season.",
    attributes: { gender: "Unisex", fit: "Relaxed", waist: "Hip length", leg: "—", material: "100% organic cotton", weight: "420 gsm", madeIn: "Hong Kong", colorHex: "#464744" },
    tags: ["sweatshirt", "organic", "unisex"],
    size: apparelSizes,
    colors: ["Coal"],
    features: ["Loopback fleece", "Garment washed", "Ribbed trims", "Flatlock seams"],
    badge: "New",
    newArrival: true,
  },
  {
    id: 21,
    name: "Railway Canvas Trouser Olive",
    category: "Pants",
    price: 190,
    images: makeImages(21),
    image: makeImages(21)[0],
    description:
      "Wide work trousers in sturdy olive duck canvas, finished with a carpenter loop and reinforced tool pockets.",
    attributes: { gender: "Unisex", fit: "Loose", waist: "Mid", leg: "Wide", material: "100% organic cotton", weight: "10.5 oz", madeIn: "Hong Kong", colorHex: "#5b6046" },
    tags: ["canvas", "carpenter", "unisex"],
    size: denimSizes,
    colors: ["Dusty Olive"],
    features: ["Organic duck canvas", "Tool pockets", "Hammer loop", "Triple-needle seams"],
    newArrival: false,
  },
  {
    id: 22,
    name: "Tide Denim Short Sun Bleach",
    category: "Shorts",
    price: 135,
    images: makeImages(22),
    image: makeImages(22)[0],
    description:
      "Relaxed five-pocket shorts with a longer inseam and a bright, sun-bleached blue wash inspired by naturally faded denim.",
    attributes: { gender: "Unisex", fit: "Relaxed", waist: "Mid", leg: "Knee length", material: "100% organic cotton", weight: "12 oz", madeIn: "Hong Kong", colorHex: "#b5c7d0" },
    tags: ["shorts", "light wash", "summer"],
    size: denimSizes.slice(0, 5),
    colors: ["Sun Bleach"],
    features: ["Rigid denim", "Long inseam", "Zip fly", "Frayed-edge detail"],
    badge: "New",
    newArrival: true,
  },
  {
    id: 23,
    name: "West Overshirt Rust Check",
    category: "Shirts",
    price: 185,
    images: makeImages(23),
    image: makeImages(23)[0],
    description:
      "A brushed organic-cotton overshirt in a muted rust check, cut generously enough to wear as a light jacket.",
    attributes: { gender: "Men", fit: "Relaxed", waist: "Longline", leg: "—", material: "100% organic cotton", weight: "280 gsm", madeIn: "Hong Kong", colorHex: "#815244" },
    tags: ["overshirt", "check", "layering"],
    size: apparelSizes,
    colors: ["Rust Check"],
    features: ["Brushed twill", "Twin chest pockets", "Corozo buttons", "Locker loop"],
    newArrival: false,
  },
  {
    id: 24,
    name: "Rib Tank Natural Ecru",
    category: "T-Shirts",
    price: 60,
    images: makeImages(24),
    image: makeImages(24)[0],
    description:
      "A close ribbed tank in undyed organic cotton. The soft natural shade and dense stretch rib make it a dependable base layer.",
    attributes: { gender: "Women", fit: "Slim", waist: "Hip length", leg: "—", material: "95% organic cotton, 5% elastane", weight: "250 gsm", madeIn: "Hong Kong", colorHex: "#d8cfba" },
    tags: ["tank", "undyed", "organic"],
    size: apparelSizes,
    colors: ["Natural Ecru"],
    features: ["Dense stretch rib", "Bound neckline", "Undyed fabric", "Garment washed"],
    newArrival: false,
  },
  {
    id: 25,
    name: "Quarry Twill Overshirt Stone",
    category: "Shirts",
    price: 128,
    images: makeImages(25),
    image: makeImages(25)[0],
    description:
      "A relaxed stone-grey overshirt cut from substantial organic-cotton twill. The softly washed surface, twin chest pockets, and clean curved hem make it an easy layer through changing weather.",
    attributes: { gender: "Unisex", fit: "Relaxed", waist: "Longline", leg: "—", material: "100% organic cotton", weight: "285 gsm", madeIn: "Hong Kong", colorHex: "#8d8a82" },
    tags: ["overshirt", "twill", "stone grey"],
    size: apparelSizes,
    colors: ["Stone Grey"],
    features: ["Organic cotton twill", "Twin chest pockets", "Corozo buttons", "Soft garment wash"],
    badge: "New",
    newArrival: true,
  },
];

const adjustedPrices = [159, 168, 148, 156, 172, 138, 174, 152, 166, 158, 146, 154, 162, 118, 180, 112, 176, 170, 58, 108, 142, 92, 126, 48, 128];
const detailNotes = {
  Jeans: "The balanced construction is comfortable from the first wear and develops a personal character over time. Pair it with simple layers, wash only when needed, and follow the care label to preserve the color and shape.",
  Pants: "Practical pocketing and durable seams support daily movement without adding bulk. The cloth softens with wear while retaining its shape, making this an easy option for workdays, travel, and relaxed weekends.",
  Jackets: "Designed as a dependable mid-weight layer, it has enough room for a tee or knit without feeling oversized. Thoughtful reinforcement at high-stress points helps it stay in regular rotation season after season.",
  Shirts: "The relaxed cut works buttoned on its own or open over a base layer. Breathable cotton, clean finishing, and useful pockets make it suitable for indoor wear and mild days outside.",
  Skirts: "The considered waist and easy line create movement without sacrificing structure. Functional pockets and durable stitching make it practical for everyday styling across seasons.",
  "T-Shirts": "Made for direct-to-skin comfort with a substantial hand and tidy finishing. Wear it alone or as a base layer; a gentle cool wash and air drying will help retain its shape.",
  Sweatshirts: "A soft, substantial layer with comfortable volume through the body and sleeves. Durable rib trims help hold the silhouette, while the breathable loopback interior makes it useful across seasons.",
  Shorts: "The relaxed cut leaves room to move while the structured cotton keeps a clean outline. Practical five-pocket construction makes it an uncomplicated warm-weather staple.",
};

const productData = productCatalog.map((product, index) => ({
  ...product,
  price: adjustedPrices[index],
  description: `${product.description} ${detailNotes[product.category] || "Built with useful details and a versatile silhouette for repeat everyday wear."}`,
  attributes: { ...product.attributes, madeIn: "Hong Kong" },
}));

export const categories = ["All", ...new Set(productData.map((product) => product.category))];
export const newArrivals = productData.filter((product) => product.newArrival);

export default productData;
